import PropTypes from 'prop-types'

/**
 * @typedef {Object} CameraView
 * @property {string} [cameraViewId]    - Id of the camera view.
 * @property {string} [name]            - name of the camera view.
 * @property {string} [type]            - type of the camera view, one of FRONT, DRIVER, AUXILIARY.
 */
export const cameraViewPropType = PropTypes.shape({
    cameraViewId: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.oneOf(['FRONT', 'DRIVER', 'AUXILIARY'])
})
